export default "__VITE_ASSET__BGFQYKpA__"